import * as React from 'react';
import UserManager from './userManager';
import useUser from '../../../../hooks/useUser';
import User, { UserOktaStatus } from '../../../../models/user';
import { useParams } from 'react-router';

/**
 * Edit an existing user
 */
const EditUser = () => {
  const defaultUser: User = {
    id: null,
    firstName: '',
    lastName: '',
    email: '',
    role: 'User',
    accessLevel: '',
    status: UserOktaStatus.ACTIVE,
    enhancedData: false,
    title: '',
    department: '',
    assignedApps: [],
    assignedClients: [],
    assignedTags: [],
    assignedSegmentation: [],
    isFederated: false,
    activate: true
  };
  const { userId } = useParams<{ userId: string }>();
  const [loading, setLoading] = React.useState<boolean>(true);
  const [user, setUser] = React.useState<User>(defaultUser);
  const { fetchUser } = useUser();

  // Fetches the user information for the page on mount
  React.useEffect(() => {
    if (!loading) setLoading(true);
    fetchUser(userId).then((user) => {
      user.activate =
        UserOktaStatus[user.status] === UserOktaStatus.ACTIVE ||
        UserOktaStatus[user.status] === UserOktaStatus.PROVISIONED ||
        UserOktaStatus[user.status] === UserOktaStatus.SUSPENDED ||
        UserOktaStatus[user.status] === UserOktaStatus.LOCKED_OUT;
      setUser(user);
      setLoading(false);
    });
  }, []);

  return <UserManager isNewUser={false} loading={loading} user={user} />;
};

export default EditUser;
